import MembershipAnalyticsByMonthReportView from "../../features/MetabaseDashboard/MembershipAnalyticsByMonthReportView"

const MembershipAnalyticsByMonth = () => {
  return (
    <div><MembershipAnalyticsByMonthReportView /></div>
  )
}

export default MembershipAnalyticsByMonth